import { useWorkOrderQuotationMap } from '@/core/domain/NetReport/WorkOrder/WorkOrder.hook';
import { ReportWorkOrderQuotationMapRequest } from '@/core/domain/NetReport/WorkOrder/WorkOrder.types';
import { useReportGenerate } from '@/hooks';
import { FileType } from '@/hooks/useFileLoading';

import { Checkbox, Modal, ModalProps } from 'antd';
import { useState } from 'react';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  format?: FileType;
  workOrderId?: number;
  complementNumber?: number;
}

export default function WorkOrderReportQuotationMapModal({
  onCancel,
  open,
  format = 'PDF',
  workOrderId,
  complementNumber,
}: Props) {
  const generateReportQuotationMap = useWorkOrderQuotationMap();

  const [includeSuppliedPart, setIncludeSuppliedPart] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);

  const report = useReportGenerate();

  const handleGenerateReport = async () => {
    if (!!workOrderId && typeof complementNumber === 'number') {
      const obj: ReportWorkOrderQuotationMapRequest = {
        workOrderId,
        complementNumber,
        onlyInternal: !includeSuppliedPart,
        outOfStock,
      };

      const result = await generateReportQuotationMap.mutateAsync(obj);

      if (format === 'PDF') {
        report.downloadFile({
          result,
          fileName: 'relatorio-mapa-cotacao.pdf',
        });
      } else {
        report.openFile({
          result,
          fileName: 'relatorio-mapa-cotacao.pdf',
          fileType: 'application/pdf',
        });
      }

      onCancel();

      setIncludeSuppliedPart(false);
      setOutOfStock(false);
    }
  };

  return (
    <Modal
      title="Mapa de Cotação"
      okText="Gerar relatório"
      confirmLoading={generateReportQuotationMap.isLoading}
      zIndex={2000}
      onOk={handleGenerateReport}
      open={open}
      onCancel={onCancel}
      destroyOnClose
    >
      <Checkbox onChange={(e) => setIncludeSuppliedPart(e.target.checked)}>
        Incluir peças fornecidas?
      </Checkbox>

      <Checkbox onChange={(e) => setOutOfStock(e.target.checked)}>
        Somente peça sem estoque?
      </Checkbox>
    </Modal>
  );
}
